import './App.css';
import LinkPage from './pages/LinkPage';

function App() {
  return (
    <div className="App">
      <LinkPage />
    </div>
  );
}

export default App;
